import React from "react";
import "./../../Testimonial/Testimonial.css"
import CourseTestimonialMain from "./CourseTestimonialMain";

const CourseTestimonial = () => {
  return (
    <div className="testimonialContainer">
      {/* <TestimonialHead/> */}
      <CourseTestimonialMain />
    </div>
  );
};

export default CourseTestimonial;
